import React from 'react'
import Moment from 'moment'

import { Form, Input, DatePicker } from 'formik-antd'

import { isNotValid, translateSymfonyErrorToFormik } from '../../../core/utils/form'

/* Form & Form Validation */
import * as Yup from 'yup'

import ModalForm from '../../../core/components/form/modalForm'

const { RangePicker } = DatePicker
const dateFormat = 'YYYY-MM-DD'

const validationSchema = Yup.object().shape({
  dateRange: Yup.array().required('Cannot be blank'), //.min(2, "Cannot be blank"), //.of(
  dateFrom: Yup.date().required('Cannot be blank.').typeError('Must be a date'),
  dateTo: Yup.date().required('Cannot be blank.').typeError('Must be a date')
})

export const defaultValue = {
  dateRange: undefined,
  dateFrom: '',
  dateTo: '',
  notes: ''
}

const FormNotAvailable = (props) => {
  const handleSubmit = (values, bag) => {
    const dateFrom = values.dateFrom == null ? null : Moment(values.dateFrom).format('YYYY-MM-DD')
    const dateTo = values.dateTo == null ? null : Moment(values.dateTo).format('YYYY-MM-DD')
    const { notes } = values
    const form = {
      notes,
      dateFrom,
      dateTo
    }

    props.createEventNotAvailable(form, {
      onSuccess: (data) => {
        bag.setSubmitting(false)
        props.onCancel()
      },
      onError: (error, variables, context) => {
        bag.setSubmitting(false)
        if (error.response.status === 400) {
          const data = error.response?.data
          if (isNotValid(data)) {
            bag.setErrors(translateSymfonyErrorToFormik(data?.errors?.children))
          }
        }
      }
    })
  }

  const updateRange = (setFieldValue, setFieldTouched) => (e, a) => {
    if (e) {
      // setFieldValue("dateRange",e);
      setFieldValue('dateTo', e[1])
      setFieldValue('dateFrom', e[0])
      setFieldTouched('dateRange')
    } else {
      setFieldValue('dateFrom', '')
      setFieldValue('dateTo', '')
      setFieldTouched('dateRange')
    }
    return false
  }

  const { modalVisible, onCancel } = props
  const values = { ...defaultValue }

  if (!modalVisible) {
    return null
  }
  return (
    <ModalForm
      title='Not Available'
      enableReinitialize
      initialValues={values}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      visible={modalVisible}
      render={({ setFieldValue, setFieldTouched }) => (
        <>
          <Form.Item label='From/To' name='dateRange' required>
            <RangePicker
              size='small'
              format={dateFormat}
              name='dateRange'
              onChange={updateRange(setFieldValue, setFieldTouched)}
            />
          </Form.Item>
          <Form.Item label='Notes' name='notes'>
            <Input.TextArea name='notes' placeholder='Notes' />
          </Form.Item>
        </>
      )}
    />
  )
}

FormNotAvailable.defaultProps = {
  modalVisible: false,
  createNotAvailable: async () => {},
  onCancel: async () => {}
}

export default FormNotAvailable
